import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Modal,
  Button
} from "react-bootstrap";
import { useFormik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { subscriptionActions } from '../../actions';

const AddSubscription = ({ userId }) => {
  const dispatch = useDispatch();
  const plans = useSelector(state => state.plan.plans);
  const [show, setShow] = useState(false);
  const [plansDetails, setPlansDetails] = useState({});

  useEffect(() => {
    if (plans.length < 1) return
    let plansList = {}
    const sortedPlans = _.sortBy(plans, ['interval', 'intervalCount']);
    sortedPlans.forEach(plan => {
      if (!plan.amount) {
        const intervalNumber = plan.interval === 'day' ? 1 : (plan.interval === 'month' ? 2 : 3)
        const intervalCount = plan.intervalCount > 9 ? plan.intervalCount : `0${plan.intervalCount}`
        plansList = {
          ...plansList,
          [plan._id]: {
            key: parseInt(`${intervalNumber}${intervalCount}`),
            name: `${plan.intervalCount} ${_.capitalize(plan.interval)}`,
            id: plan._id,
            currency: plan.currency,
            intervalCount: plan.intervalCount,
            amount: plan.amount,
            interval: plan.interval
          }
        }
      }
    })
    setPlansDetails(plansList);
  }, [plans])

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userId,
      plan: '',
    },
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setStatus(null);
      try {
        await dispatch(subscriptionActions.addSubscription(values));
        handleClose();
      } catch (error) {
        setStatus((error && (error.error || error.message)) || 'Unable to add subscription');
      } finally {
        setSubmitting(false);
      }
    },

  });

  const handleClose = () => {
    setShow(false);
    formik.resetForm();
  }

  return (
    <>
      <Button onClick={() => setShow(true)} >Add Subscription</Button>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Subscription</Modal.Title>
        </Modal.Header>
        <form id="form" onSubmit={formik.handleSubmit}>
          <Modal.Body>
            {formik.status && <div className="alert alert-danger">{formik.status}</div>}
            <Row>
              <Col>
                <span>Plan:</span>
                <select id="plan" name="plan" value={formik.values.plan} onChange={formik.handleChange} required>
                  <option value="" hidden>---</option>
                  {plansDetails && Object.entries(plansDetails).map(([id, data]) =>
                    <option value={id} key={id}>{`${data.name} Free`}</option>
                  )}
                </select>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" variant="danger" onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="primary" disabled={formik.isSubmitting || !formik.values.plan}>
              {formik.isSubmitting ? 'Adding...' : 'Add'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

AddSubscription.propTypes = {
  userId: PropTypes.string
};

export default AddSubscription;
